<template>
  <v-container
    fluid
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Create Organization
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-container
          fluid
        >
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="name"
                    label="Organization Name*"
                    hint="Name for your reference - 'DBSystems'."
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <address-form
                    ref="addressForm"
                    @addressEntered="assiginAddress($event)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="organizationType"
                    menu-props="auto"
                    :items="organizations"
                    label="Organization Type*"
                    prepend-icon="mdi-domain"
                    :rules="[(v) => !!v || 'This field is required']"
                    single-line
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="phoneNumber"
                    label="Phone-Number"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="externalId"
                    label="Organization-Id*"
                    hint="Name for your reference - 'DBSYS'"
                    :rules="[v => (v || '' ).length === 5 || 'Organization id must be 5 characters']"
                    :maxlength="externalIdMax"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="alias"
                    label="Alias*"
                    hint="Name for your reference - 'DBS'"
                    :rules="[v => (v || '' ).length === 3 || 'Alias must be 3 characters']"
                    :maxlength="aliasMax"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="timeZone"
                    menu-props="auto"
                    :items="timeZonesByName"
                    label="Time Zone*"
                    prepend-icon="mdi-clipboard-text-clock-outline"
                    :rules="[(v) => !!v || 'This field is required']"
                    single-line
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="taxId"
                    menu-props="auto"
                    :items="taxRates"
                    :item-text="showText"
                    item-value="id"
                    label="Tax Type*"
                    :rules="[(v) => !!v || 'This field is required']"
                  />
                </v-col>
              </v-row>
            </v-form>
            <br>
            <p class="text-sm-left">
              *Indicates required field
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="red darken-3"
              @click="$router.push({ name: 'Organizations' })"
            >
              Back
            </v-btn>
            <v-spacer />
            <v-btn
              color="#FF3700"
              @click="submit()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
      <br>
    </v-card>
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import AddressForm from 'src/views/dashboard/component/AddressForm';

  export default {
    name: 'CreateOrganization',
    components: {
      'centre-spinner': spinner,
      'address-form': AddressForm,
    },
    data () {
      return {
        name: '',
        organizationType: '',
        address: {},
        organizations: ['church', 'shoppingCentre', 'construction', 'restaurants', 'dental'],
        phoneNumber: null,
        alias: '',
        externalId: '',
        timeZone: '',
        aliasMax: 3,
        externalIdMax: 5,
        valid: false,
        loading: false,
        taxId: '',
      };
    },
    computed: {
      taxRates () {
        return this.$store.getters['payments/getTaxRates'];
      },
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
      allTimeZones () {
        return this.$store.getters['users/getTimeZones'];
      },
      timeZonesByName () {
        return Object.keys(this.allTimeZones).map((key) => ({ text: key, value: this.allTimeZones[key] }));
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchTaxRates();
      await this.getCountryCodes();
      await this.getAllTimeZone();
      this.loading = false;
    },
    methods: {
      submit () {
        this.$refs.addressForm.getEnteredAdress();
        if (this.$refs.form.validate() === false || Object.keys(this.address).length === 0) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('organizations/createOrganization', {
          name: this.name,
          type: this.organizationType,
          timezone: this.timeZone,
          external_id: this.externalId.toUpperCase(),
          address: this.address,
          phone_number: this.phoneNumber,
          alias: this.alias.toUpperCase(),
          tax_id: this.taxId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Organization created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.address = {};
          this.loading = false;
          this.$router.push({ name: 'Organizations' });
        }).catch(() => {
          this.loading = false;
        });
      },
      assiginAddress (address) {
        this.address = address;
      },
      fetchTaxRates () {
        this.$store.dispatch('payments/fetchTaxRates');
      },
      getCountryCodes () {
        this.$store.dispatch('users/fetchCountryCodes');
      },
      showText (item) {
        return `${item.name} - ${this.CountryCodeList[item.country]}`;
      },
      getAllTimeZone () {
        this.$store.dispatch('users/fetchTimeZones');
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
.date-icon-style {
  color:#37474f;
}
</style>
